import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({ standalone:false,
  selector: 'app-mat-overlay',
  templateUrl: './mat-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./mat-overlay.component.scss']
})
export class MatOverlayComponent {
  readonly width = input<number>(100);
  readonly message = input<string>("");
  readonly overlay = input<boolean>(false);
  readonly color = input<string>("primary");

}